<template>
  <div class="enterprise-page">
    <div class="hero-section">
      <div class="video">
        <MuxVideo
          mux-id="QDHpuC3CtvlGezQ7TleaLBU00V88Vq6kYUI5EA4EMAYk"
          :blur="false"
          :fallbackImage="`${baseUrl}/static/images/cube-first-frame.png`"
        />
        <div class="overlay">
          <div class="gradient"></div>
        </div>
      </div>
      <div class="title">
        <h1>Spatial AI at</h1>
        <h2>Enterprise Scale</h2>
      </div>
    </div>
    <div class="image">
      <div class="overlay-top"></div>
      <img :src="`${baseUrl}/static/images/office-group.jpg`" alt="" />
      <div class="overlay-bottom"></div>
    </div>
  </div>
</template>
<script setup>
import { useRuntimeConfig } from "nuxt/app";

const config = useRuntimeConfig();
const baseUrl = config.public.NUXT_CDN_URL;
</script>
<style lang="scss" scoped>
.enterprise-page {
  background: #000;
  color: white;
  font-family: "Book21", "Sharp Grotesk", sans-serif;
}
.hero-section {
  min-height: 100vh;
  display: flex;
  padding: 6rem 0;
  background: rgba(10, 10, 10, 0.2);
  text-align: center;
  justify-content: center;
  @include respond-below(sm) {
    padding: 4rem 0;
    height: 70vh;
  }
  .video {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: blur(1rem) contrast(1.2) brightness(0.85);
    @include respond-below(sm) {
      width: 100%;
      height: 50%;
      top: 38%;
      transform: translate(-50%, -50%);
      filter: blur(0.5rem) contrast(1.2) brightness(1);
    }
    img {
      width: 100%;
      height: 70%;
      object-fit: contain;
      // position: relative;
      position: absolute;
      left: 0%;
      z-index: 1;
      @include respond-below(sm) {
        height: 100%;
        object-fit: contain;
      }
    }
    &:deep(#mux-video) {
      width: 100%;
      height: 70%;
      object-fit: contain;
      @include respond-below(sm) {
        height: 100%;
        object-fit: contain;
      }
    }
    &:deep(img) {
      object-fit: contain;
      @include respond-below(sm) {
        height: 100%;
        object-fit: cover;
      }
    }
    &:deep(video) {
      width: 100%;
      height: 100%;
      object-fit: contain;
      @include respond-below(sm) {
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .title {
    max-width: 1200px;
    position: absolute;
    z-index: 2;
    bottom: 8%;
    margin-top: 3rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    letter-spacing: clamp(-2px, 1.5vw, -8.68px);
    line-height: clamp(40px, 20vw, 140.6px);
    @include respond-below(sm) {
      bottom: 5%;
    }
    // gap: rem;
    h1 {
      text-align: start;
      font-size: clamp(30px, 8vw, 124px);
      background: radial-gradient(
        55.95% 97.37% at 46.69% 2.63%,
        // #ffb571 0,
        #477ff4 36.01%,
        // #07bda9 36.01%,
        // #c2cbfe
        #fff 82.09%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      @include respond-below(lg) {
        padding-left: 3.5rem;
        line-height: 1.1;
      }
      @include respond-below(sm) {
        margin-bottom: 0rem;
        padding-left: 0rem;
        line-height: 1.5;
        text-align: center;
        font-size: clamp(30px, 13vw, 124px);
      }
    }
    h2 {
      font-size: clamp(30px, 8vw, 124px);
      text-align: end;
      color: #d8d7d7e6;
      @include respond-below(lg) {
        padding-right: 3.5rem;
        line-height: 1.1;
      }
      @include respond-below(sm) {
        margin-bottom: 1.5rem;
        padding-right: 0rem;
        text-align: center;
        font-size: clamp(30px, 13vw, 124px);
      }
    }
  }
}
.image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: relative;
  .overlay-top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 25vh;
    z-index: 1;
    background: linear-gradient(
      180deg,
      #000 0,
      rgba(0, 0, 0, 0.738) 19%,
      rgba(0, 0, 0, 0.541) 34%,
      rgba(0, 0, 0, 0.382) 47%,
      rgba(0, 0, 0, 0.278) 56.5%,
      rgba(0, 0, 0, 0.194) 65%,
      rgba(0, 0, 0, 0.126) 73%,
      rgba(0, 0, 0, 0.075) 80.2%,
      rgba(0, 0, 0, 0.042) 86.1%,
      rgba(0, 0, 0, 0.021) 91%,
      rgba(0, 0, 0, 0.008) 95.2%,
      rgba(0, 0, 0, 0.002) 98.2%,
      transparent
    );
  }
  .overlay-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 15vh;
    z-index: 1;
    background: linear-gradient(
      0deg,
      #000 0,
      rgba(0, 0, 0, 0.738) 19%,
      rgba(0, 0, 0, 0.541) 34%,
      rgba(0, 0, 0, 0.382) 47%,
      rgba(0, 0, 0, 0.278) 56.5%,
      rgba(0, 0, 0, 0.194) 65%,
      rgba(0, 0, 0, 0.126) 73%,
      rgba(0, 0, 0, 0.075) 80.2%,
      rgba(0, 0, 0, 0.042) 86.1%,
      rgba(0, 0, 0, 0.021) 91%,
      rgba(0, 0, 0, 0.008) 95.2%,
      rgba(0, 0, 0, 0.002) 98.2%,
      transparent
    );
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @include respond-below(sm) {
    height: fit-content;
  }
}
</style>
